import React, { useEffect, useRef, useState } from "react";
import bgvideo from "../../images/bgvideo.mp4";
import logo from "../../images/logo.png";
import facebook from "../../images/facebook.svg";
import google from "../../images/google.svg";
import twitterfill from "../../images/twitter-fill.svg";
import { Link } from "react-router-dom";
import { callApi } from "../common/API/Api";
import { useNavigate } from "react-router-dom";
import LanguageSwitcher from "../common/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import { getBaseUrl } from "../common/BaseUrl";
const Forgotpassword = () => {
  document.title =   "Equlix";
       const { t } = useTranslation();
  let base_url = getBaseUrl()
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [passworddata, setPassworddata] = useState();
  const [validmessage, setvalidmessage] = useState({
    email: "",
    error: "",
  });
  const setuplogindata = (key, value) => {
    setPassworddata((state) => ({
      ...state,
      [key]: value,
    }));
  };

  const forgotpasswordvalidaction = (passworddata) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!passworddata?.email) {
      setvalidmessage((state) => ({
        ...state,
        email: t("Email is Required"),
        error: "",
      }));
      return;
    } else if (!emailRegex.test(passworddata?.email)) {
      setvalidmessage((state) => ({
        ...state,
        email: "Please enter a valid email address.",
        error: "",
      }));
      return;
    } else {
      setvalidmessage((state) => ({
        ...state,
        email: "",
      }));
    }
    Forgotpassword(passworddata);
  };
  const Forgotpassword = async (passworddata) => {
    try {
        setLoading(true);
      localStorage.setItem("token", "");
      const formData = new FormData();
      for (let key in passworddata) {
        if (passworddata.hasOwnProperty(key)) {
          formData.append(key, passworddata[key]);
        }
      }
      let postdata = formData;
      let res = await callApi(postdata, `api/forget-password`, "POST");
      if (res?.data?.success) {
        setvalidmessage((state) => ({
          ...state,
          success: res?.data?.message,
        }));
      } else {
        setvalidmessage((state) => ({
          ...state,
          error: res?.data?.message || "Forgot password failed",
        }));
      }
    } catch (err) {
      console.error("Error during Forgot password:", err);
    } finally {
      setLoading(false);
    }
  };
  const videoRef = useRef(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const handleVideoEnd = () => {
    // Begin the black screen transition effect
    setIsTransitioning(true);
    // Delay to show the black screen for 1 second, then restart video smoothly
    setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.currentTime = 0; // Reset to the start
        videoRef.current.play(); // Start playing from the beginning
      }
      setIsTransitioning(false); // Remove black screen transition
    }, 100); // Show black screen for 1 second
  };

  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      // Listen for the video's `timeupdate` to detect nearing end
      const handleTimeUpdate = () => {
        if (video.duration - video.currentTime <= 1) {
          setIsTransitioning(true); // Start fading out near the end
        }
      };

      video.addEventListener('timeupdate', handleTimeUpdate);
      video.addEventListener('ended', handleVideoEnd); // Trigger on end

      // Automatically play the video on component load
      video.play();

      return () => {
        video.removeEventListener('timeupdate', handleTimeUpdate);
        video.removeEventListener('ended', handleVideoEnd);
      };
    }
  }, []);
  return (
    <div className="theme-color-1">
      <div className="mainLoginbg">
      <div style={{ position: 'relative', overflow: 'hidden' }}>
     
     {/* Video element */}
     <video
       ref={videoRef}
       playsInline
       loop={false} // Set loop to false to control replay manually
       muted
       autoPlay
       style={{ width: '100%', height: '100%', objectFit: 'cover', opacity :!isTransitioning ? 1 : 0 ,      transition: 'opacity 1s ease-in-out', }}
     >
       <source src={bgvideo} type="video/mp4" />
     </video>

     {/* Black screen overlay for transition */}
     <div
       style={{
         position: 'absolute',
         top: 0,
         left: 0,
         width: '100%',
         height: '100%',
         backgroundColor: 'black',
         opacity: isTransitioning ? 1 : 0,
         transition: 'opacity 1s ease-in-out', // Smooth transition for fade effect
         pointerEvents: 'none', // Allow clicks to pass through
       }}
     />
   </div>
        {/* <video playsInline loop muted autoPlay>
          <source src={bgvideo} type="video/mp4" />
        </video> */}
        {/* <video playsinline="" loop="" muted="" autoplay="">
            <source src="images/bgvideo.mp4" type="video/mp4"/>
         </video> */}

        <section className="loginRegisterform maxwidth">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-6 col-md-8">
                <div className="public-header">
                   <div className="site_logo">
                  <Link to={`${base_url}`}>
                    <img src={logo} alt="" />
                  </Link>
                </div>
  <LanguageSwitcher/>
                </div>

                <form action="#">
                  <div className="form-title">
                    <h4>{t("Forgot Password")}</h4>
                  </div>
                  <div className="form-group">
                    <input
                      onChange={(e) => setuplogindata("email", e.target.value)}
                      type="email"
                      className={
                        validmessage?.email
                          ? "form-control border-danger"
                          : "form-control"
                      }
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      placeholder={t("Email address")}
                    />
                    {validmessage?.email ? (
                      <p className="p-0 text-danger">{validmessage?.email}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  {validmessage?.error ? (
                    <p className="p-0 text-danger">{validmessage?.error}</p>
                  ) : (
                  ""
                  )}
                  {validmessage?.success  ? (
                    <>
                    <p className="p-0 text-success">{validmessage?.success}</p>
                     <div class="alertBox">
    <div class="alert alert-warning" >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(240,187,64,1)"><path d="M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017ZM10.9999 16.0002V18.0002H12.9999V16.0002H10.9999ZM10.9999 9.00017V14.0002H12.9999V9.00017H10.9999Z"></path></svg>
        <ul>
          <li>Please check your junk folder and spam folder.</li>
        </ul>
    </div>
</div></>
                  ) : (
                    ""
                  )}
                  {loading ? (
                    <button
                      type="button"
                      className="btn bg_btn"
                    >
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>{" "}
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn bg_btn"
                      onClick={() => forgotpasswordvalidaction(passworddata)}
                    >
                      {t("Send Verify Link")}
                    </button>
                  )}
                  <p>
                    {t("Don't have an account?")}{" "}
                    <Link to={`${base_url}signup`}>{t("Sign up")}</Link>
                  </p>
                  {/* <div className="borderline"></div>
                  <div className="or">Or</div> */}

                  {/* <div className="social_icon">
                    <Link to="" onClick={(e)=>e.preventDefault()}>
                      <img src={facebook} alt="" /> Facebook
                    </Link>
                    <Link to="" onClick={(e)=>e.preventDefault()}>
                      <img src={google} alt="" /> Google
                    </Link>
                    <Link to="" onClick={(e)=>e.preventDefault()}>
                      <img src={twitterfill} alt="" /> Twitter
                    </Link>
                   <a href="javascript:;"><img src="images/app.svg"></a>  
                  </div> */}
                </form>
              </div>
              {/* <div className="col-xl-6 col-md-6">
                     <div className="loginCard">
                        <img src="images/login-bg.png">
                        <div className="shorttext">
                           <h4>Secure and Simple Access</h4>
                           <p>Log in to your Equlix account securely. Access your trading dashboard and manage your portfolio with ease. Your data is protected by top-notch security measures.</p>
                        </div>
                     </div>
                  </div>  */}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Forgotpassword;
